(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('Ruolo', Ruolo);

    Ruolo.$inject = ['$resource'];

    function Ruolo ($resource) {
        var resourceUrl =  'api/ruolos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
